import React from 'react';
import { Entities } from '../components';

export default function EntityDetailsPage(){
    return <>
        {/* <SimpleHeader title={`Pauta`} /> */}
        <Entities.Details />
    </>
}
